import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { PriceCard } from './PriceCard';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section id="comprar" className="w-full bg-sage-light/50 py-16 sm:py-24" data-id="element-11" data-mp="at8ua5ebcp9q">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-12" data-mp="fsbsb5vvlv87">
        <div className="flex flex-col items-center" data-id="element-13" data-mp="1u5bl2j26bvr">
          <SectionHeading eyebrow="Incluido en tu compra hoy" title="Llevate el libro digital + 3 bonos de regalo" intro="Todo lo que necesitás para empezar hoy mismo, en un solo paquete completo." data-id="element-14" data-mp="1whsrdgzsi7r" />
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-15" data-mp="3t1rdapm7w49z">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.isMain ? BookOpenIcon : GiftIcon;
          return <motion.article key={bonus.tag} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.45,
            ease: 'easeOut',
            delay: index % 2 * 0.08
          }} className={`flex h-full flex-col overflow-hidden rounded-4xl border bg-cream ${bonus.isMain ? 'border-clay/40 shadow-xl shadow-ink/10 lg:col-span-2 lg:flex-row' : 'border-linen'}`} data-id="element-16" data-mp="1r8a59ku6d1ep" data-mpi={index}>
                {bonus.image && <div className={`shrink-0 overflow-hidden bg-sand ${bonus.isMain ? 'lg:w-2/5' : ''}`} data-id="element-17" data-mp="2uibudppshkkp">
                    <img src={bonus.image} alt={bonus.title} className="h-56 w-full object-cover lg:h-full" loading="lazy" data-id="element-18" data-mp="33fm8rjxwlptu" />
                  </div>}
                <div className="flex flex-1 flex-col p-7 sm:p-8" data-id="element-19" data-mp="3chv39kmwh2k0">
                  <span className={`inline-flex w-fit items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-[0.16em] ${bonus.isMain ? 'bg-clay text-cream' : 'bg-sage-light text-sage-dark'}`} data-id="element-20" data-mp="3hhzotp2o0nh3">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="2ttzwikppgp0e" />
                    {bonus.tag}
                  </span>
                  <h3 className="mt-4 font-display text-2xl font-medium leading-snug text-ink sm:text-3xl" data-id="element-22" data-mp="2xrxnnt31dl6f">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 text-lg leading-relaxed text-muted" data-id="element-23" data-mp="37klhqg2mtb1g">
                    {bonus.description}
                  </p>
                  <p className="mt-6 border-t border-linen pt-4 text-sm font-semibold uppercase tracking-[0.12em] text-sage-dark" data-id="element-24" data-mp="2a2d1l1bl67sx">
                    {bonus.footnote}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-12" data-id="element-25" data-mp="22lg71cdjk3cp">
          <PriceCard ctaLabel="Quiero mi libro + los 3 bonos" data-id="element-26" data-mp="1xlttt2xpqn3w" />
        </div>
      </div>
    </section>;
}